var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterEasColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "-459 261 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#424D56",
    d: "M-451.6 291.8c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2v-22c0-1.1-.9-2-2-2h-22c-1.1 0-2 .9-2 2v22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEC00",
    d: "M-448.5 270.9h8.8v8.8h-8.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E54C3C",
    d: "M-437.5 270.9h8.8v8.8h-8.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00DBFF",
    d: "M-448.5 281.9h8.8v8.8h-8.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#66A51C",
    d: "M-437.5 281.9h8.8v8.8h-8.8z"
  })));
}

export default SvgFilterEasColor;